"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maritalStatusesParentChildrenSiblingsFamilyInformationList = exports.maritalStatusesApplicantSpouseFamilyInformationList = exports.maritalStatusesList = void 0;
exports.maritalStatusesList = [
    {
        label: "Annulled Marriage",
        value: "09",
    },
    {
        label: "Common-Law",
        value: "03",
    },
    {
        label: "Divorced",
        value: "04",
    },
    {
        label: "Legally Separated",
        value: "05",
    },
    {
        label: "Married",
        value: "01",
    },
    {
        label: "Single",
        value: "02",
    },
    {
        label: "Unknown",
        value: "00",
    },
    {
        label: "Widowed",
        value: "06",
    },
];
// For the IMM 5645 E - Applicant
exports.maritalStatusesApplicantSpouseFamilyInformationList = [
    {
        value: "1",
        label: "Annulled marriage",
    },
    {
        value: "2",
        label: "Common-law",
    },
    {
        value: "3",
        label: "Divorced",
    },
    {
        value: "4",
        label: "Legally separated",
    },
    {
        value: "5",
        label: "Married-physically present",
    },
    {
        value: "6",
        label: "Married-not physically present",
    },
    {
        value: "7",
        label: "Single",
    },
    {
        value: "8",
        label: "Widowed",
    },
];
// For the IMM 5645 E - Parents, Children and Siblings
exports.maritalStatusesParentChildrenSiblingsFamilyInformationList = [
    {
        value: "1",
        label: "Annulled marriage",
    },
    {
        value: "2",
        label: "Common-law",
    },
    {
        value: "3",
        label: "Divorced",
    },
    {
        value: "4",
        label: "Legally separated",
    },
    {
        value: "5",
        label: "Married",
    },
    {
        value: "6",
        label: "Single",
    },
    {
        value: "7",
        label: "Widowed",
    },
];
